import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsWorkOrder, PmsWorkOrder } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsWorkOrder>
    useData={usePmsWorkOrder}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
